<template>
    <transition name="slide-fade">
        <div class="modal" data-cy="modal_history_copy_success" :class="{'open' : open}" v-if="open">
            <div class="modal-content" :class="{'isBottom': isBottom}">
                <div class="bg-a-black-000926 p-3 rounded-sm w-28 h-16 m-auto">
                    <img class="mx-auto w-5 h-5" src="@/assets/icon/ic-check-circle.svg">
                    <div class="text-center text-16 text-a-white-ffffff mt-2" data-cy="text_history_copy_success">{{lbl.serial.copy_success}}</div>
                </div>
            </div>
        </div>
    </transition>

    <!-- <transition name="fade">
        <div class="modal-backdrop" v-if="open"></div>
    </transition> -->
</template>
<script>
import LocaleMixin from "@/mixin/LocaleMixin.js";

export default {
    name: "CopySerialSuccessModal",
    mixins: [LocaleMixin],
    props: {
        controller: Object,
    },
    data: function() {
        return {
            open: false,

            type: null,
            campaign: null,
            isBottom: false,
            btnOk: '',
            btnCancel: '',
            busModal: null,
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    watch: {
        '$route.path': function() {
            if (this.open) {
                this.hide();
            }
        },
    },
    methods: {
        show: function(config) {
            this.campaign = config.campaign;
            this.btnOk = config.btnOk;
            this.btnCancel = config.btnCancel;
            this.isBottom = config.isBottom;

            document.body.classList.add('not-scroll');
            this.open = true;
            setTimeout(() => {
                document.body.classList.remove('not-scroll');
                this.open = false;
            }, 1000);
        },
        hide: function() {
            document.body.classList.remove('not-scroll');
            this.open = false;
        },
    },
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
    @import "@/style/modal.scss";
    .modal {
        @extend %modal;

        .modal-content {
            position: absolute;
            opacity: 0.8;

            &.isBottom{
                bottom: 160px;
            }
        }
    }
</style>
